var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 29,
    viewBox: "0 0 42 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.28418 6.32649C5.30916 6.11605 5.27508 5.90359 5.18472 5.7064C5.09437 5.50921 4.95028 5.33284 4.76418 5.19166L0.92918 1.28116V0.694489H12.8415L22.0498 17.7812L30.1445 0.694489H41.5V1.27932L38.2175 3.93949C38.0801 4.03003 37.9739 4.15004 37.9099 4.28706C37.8459 4.42408 37.8264 4.57311 37.8535 4.71866V24.273C37.826 24.4186 37.8452 24.5677 37.9093 24.7048C37.9733 24.8419 38.0798 24.9619 38.2175 25.0522L41.422 27.7123V28.2972H25.3107V27.7123L28.6235 24.9862C28.9528 24.7112 28.9528 24.6287 28.9528 24.2088V8.40182L19.725 28.233H18.4792L7.73685 8.40182V21.6917C7.64801 22.2508 7.86685 22.8137 8.33268 23.2188L12.6487 27.65V28.2348H0.411346V27.65L4.72735 23.2188C4.95441 23.0186 5.12301 22.7762 5.21969 22.5111C5.31637 22.2459 5.33845 21.9653 5.28418 21.6917V6.32649Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.536e8c7b32619894cfc6b9f80569790f.svg";
export { ForwardRef as ReactComponent };